// Public chart pages (/tiktok-trending-songs, charts.layout): their own Vite entry. Starts Alpine for the top bar, the
// paywall dialog and the chart's table (columns make way on narrow screens instead of scrolling, ui-rows). Signed in,
// the layout also loads Livewire for the top bar's search (html[data-livewire]), which brings and starts its own
// Alpine, so the components register on that one. No app.js otherwise; from it only the consent-gated PostHog.
import './alpine/ui-tip';
import './alpine/ui-rows';
import './tracking-consent';
import Alpine from 'alpinejs';
import { uiDropdown, uiDialog } from './alpine/ui-controls';
import { uiTopbar } from './alpine/ui-nav';
import { uiSegmented } from './alpine/ui';

// The paywall a locked cell or song opens: what it says depends on what was clicked.
const chartPage = (paywalls) => ({
    wall: paywalls.numbers,
    paywall(kind, song = null) {
        const base = paywalls[kind] ?? paywalls.numbers;
        this.wall = { ...base, title: song ? base.title.replace(':song', song) : base.title };
        this.$dispatch('ui-open', 'chart-paywall');
    },
});

const register = (A) => {
    Object.entries({ uiDropdown, uiDialog, uiTopbar, uiSegmented, chartPage }).forEach(([name, fn]) => A.data(name, fn));
};
if (document.documentElement.hasAttribute('data-livewire')) {
    document.addEventListener('alpine:init', () => register(window.Alpine));
} else {
    window.Alpine = Alpine;
    register(Alpine);
    Alpine.start();
}
